import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient/bpm/BpmApiClient'

export default {
	async [actionTypes.BPM.BUSCAR_LISTAGEM_PERFIL_POR_ATIVIDADE](context, filtros) {
		const { data } = await api.buscarListagemPerfilPorAtividade(filtros)
		return data
	},

	async [actionTypes.BPM.BUSCAR_PROXIMAS_ATIVIDADES](context, filtros) {
		const { data } = await api.buscarProximasAtividades(filtros)
		return data
	},

	async [actionTypes.BPM.ENCAMINHAR_ATIVIDADE](context, body) {
		await api.encaminharAtividade(body)
	},
}
